import { render, staticRenderFns } from "./TheFramedWindow.vue?vue&type=template&id=3ea8c6e2"
import script from "./TheFramedWindow.vue?vue&type=script&lang=js"
export * from "./TheFramedWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports